export default __webpack_public_path__ + "static/B0172-035e6b76babe03d62e62e16be8e0eebf.png";